module.exports = __webpack_public_path__ + "img/quiz_ox_character.65a9176c.png";